export const isFunction = (value: any): value is Function =>
	typeof value === 'function';
